import FormBaseModel from '@cp-models/FormBaseModel';
import Module from '@cp-models-common/Module'
import Discount from '@cp-models-common/Discount'

export default class PlanModule extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'plan_id': 'number',
            'module_id': 'number',
            'product_id': 'number',
            'name': 'string',
            'price': 'number',
            'price_discount': 'number',
            'price_type': 'string',
            'amount': 'number',
            'amount_valid_until': 'number',
            'valid_until': 'any',
            'type': 'string',
            'sub_type': 'string',
            'module': Module,
            'discounts': [Discount]
        }
    }

    get validUntil()
    {
        return this.formatDate(this.valid_until)
    }

    get priceBr()
    {
        return this.formatCurrency(this.price)
    }

    get priceDiscountBR()
    {
        return this.formatCurrency(this.price_discount)
    }

}
